<template>
  <div class="table-search-bar" :class="{'search-more': moreBtn, open: state}" :style="state ? 'height: 33px;overflow: hidden;' : ' height: auto;overflow: initial;'">
    <slot></slot>
    <div class="btn-list">
      <slot name="btnList"></slot>
    </div>
    <div class="more-list">
      <slot name="more"></slot>
    </div>
    <div class="more-btn" v-if="moreBtn">
      <el-button size="small" @click="state=!state">
        <template v-if="state">
          更多筛选<el-icon><el-icon-arrow-down /></el-icon>
        </template>
        <template v-else>
          收起筛选<el-icon><el-icon-arrow-up /></el-icon>
        </template>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-search-bar',
  props: {
    moreBtn: { //更多按钮
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      state: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.table-search-bar {
  display: flex;
  justify-content: flex-end;
  position: relative;
  box-sizing: border-box;
  .more-btn { // 更多按钮
    position: absolute;
    right: 0px;
    bottom: 0;
    .el-button{
      padding: 0px 3px;
      color: #697887;
      font-size: 12px;
      background: #F5F6F7;
      border-color: transparent;
    }
  }
}
</style>